import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetAccountTypeSummaryQuery } from "../../../services/Reports";
import {
  getAccountTypeSummaryRequest,
  getAccountTypeSummaryFailure,
  getAccountTypeSummarySuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allAccountTypeSummary,
    isLoading: accountTypeSummaryLoading,
    isError: accountTypeSummaryError,
  } = useGetAccountTypeSummaryQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.accountTypeSummaryPageNo,
    pageSize: state.accountTypeSummaryPageSize,
    fromDate: new Date(state.accountTypeSummaryFromDate).toLocaleDateString(),
    toDate: new Date(state.accountTypeSummaryToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (accountTypeSummaryLoading) {
      dispatch(getAccountTypeSummaryRequest());
    }
    if (accountTypeSummaryError) {
      dispatch(getAccountTypeSummaryFailure(accountTypeSummaryError));
    }
    if (allAccountTypeSummary) {
      dispatch(
        getAccountTypeSummarySuccess({
          data: allAccountTypeSummary.data.accountTypeSummary[0].data || [],
          totalPages:
            allAccountTypeSummary.data.accountTypeSummary[0].metadata[0]
              ?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allAccountTypeSummary,
    profileData,
    state.accountTypeSummaryFromDate,
    state.accountTypeSummaryToDate,
    state.accountTypeSummaryPageNo,
    state.accountTypeSummaryPageSize,
  ]);
  return <></>;
};
export default Content;
